import { ApolloClient, ApolloProvider, InMemoryCache } from '@apollo/client';
import { FunctionComponent } from 'react';
import { apiLinks } from './links';
import { useAuth, hasAuthParams } from 'react-oidc-context';
import { LogoSpinner } from '../components/shared/LogoSpinner/LogoSpinner';
import { useEffect } from 'react';

if (import.meta.env.VITE_BASE_API_URL === undefined) {
  throw new Error('API URL required');
}

export const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: apiLinks,
  connectToDevTools: true,
  credentials: 'include',
});

interface Props {
  children: JSX.Element;
}

export const ManagedApolloProvider: FunctionComponent<Props> = ({ children }) => {
  const auth = useAuth();

  useEffect(() => {
    const nav = auth.activeNavigator;

    if (auth.isLoading && nav === 'signinRedirect' && !hasAuthParams()) {
      auth.signinSilent().catch((e) => {
        const url = new URL(window.location.href);

        if (url.search || url.hash) {
          url.search = '';
          url.hash = '';
          window.history.replaceState({}, document.title, url.toString());
        }
      });
    }
  }, [auth]);

  if (auth.isLoading && !auth.isAuthenticated) {
    return (
      <div className="spinner-wrapper">
        <LogoSpinner size="large" />
      </div>
    );
  }

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
